import { InfoCardPopoverRow } from "@/components/InfoCardPopover";
import { prospectJobTitle } from "@/utils/prospectJobTitle";

import { ListPerson } from "../../schema/list";

/**
 * Rows rendered in the lead Name-column {@link InfoCardPopover} hover card (name, job title,
 * persona category / priority, location). Extracted from `EditableNameColumn` in `allColumns.tsx`
 * to keep that file under the file-length ratchet.
 */
export const buildLeadInfoCardRows = (row: ListPerson): InfoCardPopoverRow[] => [
	{ label: "Name", value: row.prospect?.name },
	{ label: "Job title", value: prospectJobTitle(row.prospect) },
	{ label: "Persona category", value: row.prospect?.scorePersonaCategoryResult?.result },
	{ label: "Location", value: row.prospect?.country },
	{ label: "Persona prio", value: row.prospect?.scorePersonaCategoryResult?.overallScore },
];
